import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import { DASHBOARD_GROWTH_LOCUS_DATA } from 'constants/apiRouting'
import UrlHelper from 'helpers/url'
import * as ApiRouter from 'constants/apiRouting'
import {
  FETCH_CAGES_TABLE_DATA,
  SET_CAGES_TABLE_DATA,
  FETCH_SITE_LIST,
  SET_SITE_LIST,
  FETCH_LOCUS_LIST,
  SET_LOCUS_LIST,
  FETCH_DATA_BY_CAGE,
  SET_CAGE_DATA,
} from './reducer'

function* fetchSiteList() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRouter.ACTIVE_SITES,
    })

    yield put({
      type: SET_SITE_LIST,
      list: response,
    })
  } catch (error) {
    console.log('DASHBOARD_GROWTH ERROR ', error)
  }
}

function* fetchLocusList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })
    yield put({
      type: SET_LOCUS_LIST,
      list: response,
    })
  } catch (error) {
    console.log('DASHBOARD_GROWTH ERROR ', error)
  }
}

function* fetchCageTableData() {
  try {
    // const response = yield call(fetchFromAPI, {
    //     headers: getDefaultAutorizedHeaders(),
    //     partUrl: `${API_URL_SITE_LIST}${UrlHelper.getPsfsQuery(action.payload)}`,
    // });

    const response = {
      data: [
        {
          cage: 'C1',
          type: 'seasite',
          count: '120',
          agv_weight: '120',
          total_biomass: '12',
          fcr: '24',
          sgr: '24',
        },
        {
          cage: 'C2',
          type: 'seasite',
          count: '120',
          agv_weight: '120',
          total_biomass: '12',
          fcr: '24',
          sgr: '24',
        },
        {
          cage: 'C3',
          type: 'seasite',
          count: '120',
          agv_weight: '120',
          total_biomass: '12',
          fcr: '24',
          sgr: '24',
        },
        {
          cage: 'C4',
          type: 'seasite',
          count: '120',
          agv_weight: '120',
          total_biomass: '12',
          fcr: '24',
          sgr: '24',
        },
        {
          cage: 'C5',
          type: 'seasite',
          count: '120',
          agv_weight: '120',
          total_biomass: '12',
          fcr: '24',
          sgr: '24',
        },
        {
          cage: 'C6',
          type: 'seasite',
          count: '120',
          agv_weight: '120',
          total_biomass: '12',
          fcr: '24',
          sgr: '24',
        },
      ],
      count: 6,
    }

    yield put({
      type: SET_CAGES_TABLE_DATA,
      tableData: response,
    })
  } catch (error) {
    console.log('DASHBOARD_GROWTH ERROR', error)
  }
}

function* fetchDataByCage(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(DASHBOARD_GROWTH_LOCUS_DATA, action.payload),
    })

    yield put({
      type: SET_CAGE_DATA,
      payload: response,
    })
  } catch (error) {
    console.log('DASHBOARD_GROWTH ERROR ', error)
  }
}

function* dashboardGrowthSaga() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_LOCUS_LIST, fetchLocusList)
  yield takeLatest(FETCH_CAGES_TABLE_DATA, fetchCageTableData)
  yield takeLatest(FETCH_DATA_BY_CAGE, fetchDataByCage)
}

export default dashboardGrowthSaga
